angular.module('harriApp')

    .directive('brandDirective', ['asyncGlobalHandler', 'httpHelper', 'hFormReference' , '$timeout', '$q', 'googleMaps', 'registrationApi', function(asyncGlobalHandler, httpHelper, hFormReference, $timeout, $q, googleMaps, registrationApi) {
        return {
            link: function(scope, element, attrs) {

                var formsName = [attrs.brandDirective];
                _.each(formsName, function(formName) {


                    hFormReference.getForm(formName).then(function (formObj) {

                        //var scope = formObj.scope;


                        //update User Location.
                        var beforeActiveCallBack = {};
                        beforeActiveCallBack[formName] = function () {

                            googleMaps.updateLocation();

                            //update hecs
                            scope.hecs = [];
                            registrationApi.getHecsLookup()
                                .then(function (hecs) {
                                    scope.hecs = hecs;
                                })
                                .catch(function (err) {
                                    console.error(err);
                                });

                            //update postions
                            scope.cusines = [];
                            registrationApi.getCusineLookup()
                                .then(function (cusines) {
                                    scope.cusines = cusines;
                                })
                                .catch(function (err) {
                                    console.error(err);
                                });


                        };
                        scope.beforeActiveViewCallback(beforeActiveCallBack);


                        var beforeSaveCallback = {};

                        var location = undefined;

                        beforeSaveCallback[formName] = function (formData, valid) {
                            if(!valid) return;

                            var d = $q.defer();

                            if(formData.locationAutoComplete) {
                                location = formData.locationAutoComplete;
                                delete formData.locationAutoComplete;;
                            }

                            if (formData.cusine) {
                                formData.cusine = [formData.cusine];
                            }

                            if (formData.hecs) {
                                formData.hecs = [formData.hecs];
                            }

                            //parent_id
                            if(scope.data.enterprise_id && attrs.brandDirective == 'registration/company_profile') {
                                formData.parent_id = scope.data.enterprise_id;
                            }

                            if (formData.google_place && !formData.google_place.place_id) {
                                formData.brand_name = formData.google_place.brand_name;
                                delete formData.google_place;

                                d.resolve(formData);
                            } else {

                                googleMaps.getDetails(
                                    {placeId: formData.google_place.place_id},
                                    function (response) {

                                        formData.google_place = response;

                                        d.resolve(formData);
                                    }
                                );

                            }

                            return d.promise;
                        };

                        scope.addBeforeSaveCallback(beforeSaveCallback);


                        var afterSaveCallBack = {};
                        afterSaveCallBack[formName] = function (response, formData, requestStatus) {


                            if(response.status_code == 200) {
                                scope.$parent.media_brand_id = response.data.id;
                                scope.$parent.media_brand_slug = response.data.slug;
                                scope.$parent.media_brand_name = response.data.brand_name;
                                HStorageManager.put({
                                    key: 'brand_slug',
                                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                                    value: response.data.slug
                                });
                                HStorageManager.put({
                                    key: 'brand_id',
                                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                                    value: response.data.id
                                });
                                HStorageManager.put({
                                    key: 'brand_name',
                                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                                    value: response.data.brand_name
                                });
                            }

                            var brand_id = response.data.id;

                            //save location
                            var locationDefer = $q.defer();
                            if(location && location.value) {
                                registrationApi.addBrandLocations([location.value], brand_id).then(function() {
                                    locationDefer.resolve();
                                })
                            } else {
                                locationDefer.resolve();
                            }

                            //save image
                            var uploadDefer = $q.defer();
                            if (response.status_code == 200 && scope.$files && scope.$files.length > 0) {
                                var cropping_data = scope.$coords;
                                cropping_data['brand_id'] = brand_id;
                                scope.directUpload(scope.$files, 'brand_profile_photo', scope.uploadMethod, cropping_data).then(function (imageUploadResponse) {
                                    response.data.profileImage = {uuid: imageUploadResponse.data};
                                    uploadDefer.resolve(response);
                                    scope.$image = "";
                                    scope.$croppedImage = "";
                                    scope.$files = [];
                                });
                            } else {
                                uploadDefer.resolve(response);
                            }


                            var defer = $q.defer();
                            $q.all([uploadDefer.promise, locationDefer.promise]).then(function() {
                                defer.resolve();
                            });

                            return defer.promise;
                        };

                        scope.addAfterSaveCallback(afterSaveCallBack);
                    });
                });
            }
        }
    }])

    .directive('cusineLookup', [
        'registrationApi', 'hUser',
        function (registrationApi, hUser) {
            return {
                link: function (scope, element, attrs, ctrl) {
                    scope.cusines = [];
                    if (hUser.isLoggedIn()) {
                        registrationApi.getCusineLookup()
                            .then(function (cusines) {
                                scope.cusines = cusines;
                            }).catch(function (err) {
                                console.error(err);
                            });
                    }
                }
            }
        }])

    .directive('hecsLookup', [
        'registrationApi', 'hUser',
        function(registrationApi, hUser) {
        return {
            link: function(scope, element, attrs, ctrl) {
                //update hecs
                scope.hecs = [];

                if (hUser.isLoggedIn()) {
                    registrationApi.getHecsLookup()
                        .then(function (hecs) {
                            scope.hecs = hecs;
                        }).catch(function (err) {
                            console.error(err);
                        });
                }
            }
        }
    }])

    .directive('googlePlacesAutocomplete', ['googleMaps', function (googleMaps) {
        return {
            restrict: 'A',
            link: function (scope) {
                scope.getPlace = function(location) {
                    return googleMaps.placeAutocomplete(location);
                }
            }
        };
    }])

    .directive('serverGoogleBrandSearch', ['registrationApi', '$q', function (registrationApi, $q) {
        return {
            restrict: 'A',
            link: function (scope) {

                scope.serverGoogleBrandSearch = function(location, selectedList) {
                    if(!location) return;
                    return registrationApi.ServerAndGooglePlaceBatchSearchWithPriorityToServer(location)
                }
            }
        };
    }])

    .directive('institutionSearch', ['registrationApi', function (registrationApi) {
        return {
            restrict: 'A',
            link: function (scope) {

                scope.SearchGooglePlaceForInstitutes = function(instituteName) {
                    if(!instituteName) return;

                    return registrationApi.SearchGooglePlaceForInstitutes(instituteName);
                }

            }
        };
    }])

    .directive('schedule', ['$timeout','registrationApi', function($timeout, registrationApi) {
        return {
            link: function($scope, element, attr) {

                if(!$scope.data) {
                    $scope.data = {};
                }
                if(!$scope.data.schedule) {
                    $scope.data.schedule = {};
                }

                $scope.changeSelection = function(type) {
                    if(type == 'anytime') {
                        //anytime changed
                        _.each(options, function(time) {
                            $scope.data.schedule[time] = $scope.data.schedule.anytime;
                        });
                        $scope.data.schedule.specific_times = false;

                    } else if(_.contains(options, type)) {
                        //any time of the day changed
                        $scope.data.schedule.anytime = $scope.data.schedule[type] && _.every(options, function(element) { return $scope.data.schedule[element]; });
                        $scope.data.schedule.specific_times = false;

                    } else if (type == 'specific_times') {
                        //specific_times changed
                        if($scope.data.schedule[type]) {

                            _.each(options, function (time) {
                                $scope.data.schedule[time] = false;
                            });

                            $scope.data.schedule.anytime = false;
                        }
                    }

                    updateSelection();
                };

                function updateSelection() {
                    //update week schedual
                    if($scope.data.schedule.anytime) {
                        //select everything
                        _.each(_.union(subOptions.morning, subOptions.evening, subOptions.afternoon), function(time) {
                            $scope.data.schedule[time] = $scope.data.schedule.anytime;
                        });

                    } else {

                        _.each(options, function(element) {
                            //loop for each option days and select/unselect it.
                            _.each(subOptions[element], function(day) {
                                $scope.data.schedule[day] = $scope.data.schedule[element];
                            });
                        })
                    }

                    //set fields to false by default to fix the backend stupidity
                    _.each(_.union(subOptions.morning, subOptions.evening, subOptions.afternoon, options), function(time) {
                        if(!$scope.data.schedule[time]) {
                            $scope.data.schedule[time] = false;
                        }
                    });

                    $scope.scheduleValidation();
                }

                //validate
                $scope.scheduleValidation = function() {
                    //if any suboption was selected then it's valid
                    var valid = _.some(_.union(subOptions.morning, subOptions.evening, subOptions.afternoon), function(element) {
                        return $scope.data.schedule[element];
                    });

                    $scope.forms.schedule.sunday_morning.$setValidity('selection', valid);

                    return valid;
                };
                $scope.$on('show-errors-check-validity', function () {
                    $scope.scheduleValidation();
                });


                var options = registrationApi.getAvailabilityOptions();
                var subOptions = registrationApi.getAvailabilitySubOptions();
            }
        }
    }])

//    .directive('registrationSkills', ['hFormReference', 'httpHelper', 'registrationApi', '$q', function(hFormReference, httpHelper, registrationApi, $q) {
//
//        return {
//            link: function($scope) {
//
//                var formName = 'registration/skills';
//                hFormReference.getForm(formName).then(function (formObj) {
//                    var scope = formObj.scope;
//
//                    var beforeLoadViewcallback = {};
//                    beforeLoadViewcallback[formName] = function () {
//                        var defer = $q.defer();
//
//
//                        scope.loadNextWorkHistory();
//
//                        return defer.promise;
//                    };
//                    scope.beforeActiveViewCallback(beforeLoadViewcallback);
//                });
//
//                //GET latest_position
//                //{"skills":[3, 4]}
//                //user_skills
//                registrationApi.getSkillLookup().then(function(r) {
//                    $scope.skillsList = r;
//                });
//
//            }
//        }
//
//    }])


    .directive('workHistory', ['hFormReference', '$q', 'googleMaps', 'registrationApi', 'asyncGlobalHandler', function(hFormReference, $q, googleMaps, registrationApi, asyncGlobalHandler) {
        return {
            link: function (scope, element, attrs, contr) {

                var formName = 'registration/work_history';

                //change form's data in a format that the backend understands.
                hFormReference.getForm(formName).then(function (formObj) {

                    var scope = formObj.scope;
                    var beforeSaveCallback = {};

                    scope.toWorkHistoryDetailsOrEducation = function(r) {

                        if(r.saved && r.valid) {
                            if(r.data[0].first_job) {
                                scope.goto('registration/education');
                            } else {
                                scope.goto('registration/work_history_details');
                            }
                        }
                    };

                    beforeSaveCallback[formName] = function (formData, valid) {
                        var d = $q.defer();

                        var data = [];

                        if(formData.first_job===false) {
                            delete formData.first_job;
                        } else if (formData.first_job) {
                            //submit first job alone
                            data.push({"first_job" : true});
                            return data;
                        }


                        //queue holding all google requests.
                        var googlePlaces = [];
                        for(var k in formData.brands) {
                            var workHistory = formData.brands[k];

                            //if Google place was selected, another request is made to get details
                            if(workHistory.type == "Google") {

                                //saving the order the list was created at
                                var gindex = data.push({});
                                gindex = gindex - 1;

                                (function(place_id, gindex) {
                                    var placeDefer = $q.defer();

                                    //get locations details
                                    googleMaps.getDetails({placeId: place_id}, function (r) {
                                        placeDefer.resolve({r: r, index: gindex});
                                    });

                                    googlePlaces.push(placeDefer.promise);
                                })(workHistory.value.place_id, gindex);

                            } else if(workHistory.type == "string") {
                                data.push( {brand_name: workHistory.value} );
                            } else {
                                data.push(workHistory.value);
                            }
                        }

                        //whenever google returns all requests, move and send the form.
                        $q.all(googlePlaces).then(function(responses) {
                            for(var k in responses) {
                                var obj = responses[k];
                                data[obj.index] = ({google_place: {result:obj.r}});
                            }

                            d.resolve(data);
                        });

                        return d.promise;
                    };

                    scope.addBeforeSaveCallback(beforeSaveCallback);



                    var beforeActiveCallBack = {};
                    beforeActiveCallBack[formName] = function () {
                        googleMaps.updateLocation();
                    };
                    scope.beforeActiveViewCallback(beforeActiveCallBack);

                });

            }
        };
    }])


    .directive('detailsWorkHistory', ['hFormReference', '$q', 'httpHelper', 'registrationApi','googleMaps', 'positionsDataService', function(hFormReference, $q, httpHelper, registrationApi, googleMaps, positionsDataService) {
        return {
            link: function(scope, element, attrs) {

                scope.nextWorkHistory = function() {
                    scope.loadNextWorkHistory();
                };

                scope.loadNextWorkHistory = function() {

                    if(scope.workHistoryItem && scope.workHistoryItem.remains == 0) {
                        return scope.goto('registration/education');
                    }

                    var p = registrationApi.getWorkHistoryFromQueue();
                        p.then(function(workHistoryItem) {
                        scope.reset();

                        //iniat data
                        if(!scope.data) scope.data = {};
                        if(!scope.data.details_work_history) scope.data.details_work_history = {};


                        //set Position value
                        if(workHistoryItem.workHistory.Work.Position) {
                            var position = workHistoryItem.workHistory.Work.Position;
                            scope.data.details_work_history.position_id = {name: position.name, value: position.id};
                        }

                        //description
                        if(workHistoryItem.workHistory.Work.description) {
                            scope.data.details_work_history.description = workHistoryItem.workHistory.Work.description;
                        }

                        //end_date
                        if(workHistoryItem.workHistory.Work.end_date) {
                            scope.data.details_work_history.end_date = workHistoryItem.workHistory.Work.end_date;
                        }

                        //start_date
                        if(workHistoryItem.workHistory.Work.start_date) {
                            scope.data.details_work_history.start_date = workHistoryItem.workHistory.Work.start_date;
                        }

                        //I still_work_here case
                        if(!workHistoryItem.workHistory.Work.end_date && workHistoryItem.workHistory.Work.start_date) {
                            scope.data.details_work_history.still_work_here = true;
                        }


                        //I still_work_here case
                        if(workHistoryItem.workHistory.Work.custom_position) {
                            var l = workHistoryItem.workHistory.Work.custom_position;
                            scope.data.details_work_history.position_id = {name: l, value:{custom_position:l}};
                        }



                        scope.workHistoryItem = workHistoryItem;

                    }, function(r) {
                        defer.reject(r);
                    });

                    return p;
                };


                var formName = 'registration/work_history_details';
                hFormReference.getForm(formName).then(function (formObj) {
                    var scope = formObj.scope;

                    //load and show one work history one at a time.
                    var beforeLoadViewcallback = {};
                    beforeLoadViewcallback[formName] = function() {
//                        var defer = $q.defer();

                        //loadAllWorkHistory and show one of them at a time


                        //update positions


                        positionsDataService.getSystemPositionsFlat().then(function(r) {
                            scope.positions = r;
//                            defer.resolve();
                        });

                        return scope.loadNextWorkHistory();


//                        return defer.promise;
                    };
                    scope.beforeActiveViewCallback(beforeLoadViewcallback);




                    //re-structure the data for post request
                    var beforeSaveCallback = {};
                    beforeSaveCallback[formName] = function(formData, valid) {
                        if(!valid) return;

                        formData.work_id = scope.workHistoryItem.workHistory.Work.id;

                        if(formData.still_work_here) {
                            delete formData.end_date;
                            delete formData.still_work_here;
                        }


                        if(formData.position_id && formData.position_id.custom_position) {
                            formData.custom_position = formData.position_id.custom_position;
                            delete formData.position_id;
                        } else if (formData.position_id && formData.position_id.value && formData.position_id.value.custom_position) {
                            formData.custom_position = formData.position_id.value.custom_position;
                            delete formData.position_id;
                        } else if(formData.position_id) {
                            formData.position_id = formData.position_id.value;
                        }

                        if(formData.cuisine=="" || !formData.cuisine) {
                            delete formData.cuisine;
                        } else {
                            formData.cuisine = [formData.cuisine];
                        }

                        if(formData.hecs=="" || !formData.hecs) {
                            delete formData.hecs;
                        } else {
                            formData.hecs = [formData.hecs];
                        }

                        if(!scope.workHistoryItem.workHistory.Work.is_brand_owner) {
                            //delete values if not the owner
                            try {
                                delete formData.cuisine;
                                delete formData.hecs;
                                delete formData.google_location;
                            } catch(e) {}
                        }

                        return formData;
                    };
                    scope.addBeforeSaveCallback(beforeSaveCallback);

                });
            }
        };
    }])






    .directive('education', ['hFormReference', '$q', 'googleMaps', function(hFormReference, $q, googleMaps) {
        return {
            link: function (scope, element, attrs, contr) {



                var formName = 'registration/education';

                //change form's data in a format that the backend understands.
                hFormReference.getForm(formName).then(function (formObj) {

                    var d = $q.defer();

                    var scope = formObj.scope;
                    var beforeSaveCallback = {};

                    beforeSaveCallback[formName] = function (formData, valid) {

                        var data = [];

                        //queue holding all google requests.
                        var googlePlaces = [];

                        for(var k in formData.institutions) {
                            var institution = formData.institutions[k];

                            if(institution.type == "string") {
                                data.push({ institution_name: institution.value });
                            } else if(institution.type == "Google") {

                                (function(place_id) {
                                    var placeDefer = $q.defer();

                                    //get locations details
                                    googleMaps.getDetails({placeId: place_id}, function (r) {
                                        placeDefer.resolve(r);
                                    });

                                    googlePlaces.push(placeDefer.promise);
                                })(institution.value.place_id);

                            } else {
                                data.push(institution.value);
                            }
                        }


                        $q.all(googlePlaces).then(function(responses) {
                            for(var k in responses) {
                                data.push({google_place: {result: responses[k]}});
                            }

                            d.resolve(data);
                        });

                        return d.promise;
                    };

                    scope.addBeforeSaveCallback(beforeSaveCallback);
                });

            }
        };
    }])



    .directive('detailsEducation', ['hFormReference', '$q', 'httpHelper', 'registrationApi','googleMaps', function(hFormReference, $q, httpHelper, registrationApi, googleMaps) {
        return {

            link: function(scope, element, attrs) {
                scope.nextEducation = function() {
                    scope.loadNextEducation();
                };

                scope.loadNextEducation = function() {

                    if(scope.educationItem && scope.educationItem.remains == 0) {
                        return scope.next();
                    }

                    registrationApi.getEducationFromQueue().then(function(educationItem) {
                        scope.reset();


                        if(!scope.data) scope.data = {};
                        if(!scope.data.details_education) scope.data.details_education = {};


                        if(educationItem.education.UserEducation.DegreeLookup) {
                            scope.data.details_education.degree_id = educationItem.education.UserEducation.DegreeLookup;
                        }

                        //discipline
                        if(educationItem.education.UserEducation.DisciplineLookup && educationItem.education.UserEducation.DisciplineLookup.name) {
                            scope.data.details_education.discipline = educationItem.education.UserEducation.DisciplineLookup.name;
                        }

                        //end_date
                        if(educationItem.education.UserEducation.end_date) {
                            scope.data.details_education.end_date = educationItem.education.UserEducation.end_date;
                        }

                        //start_date
                        if(educationItem.education.UserEducation.start_date) {
                            scope.data.details_education.start_date = educationItem.education.UserEducation.start_date;
                        }

                        scope.educationItem = educationItem;

                    }, function(r) {
                        defer.reject(r);
                    });
                };


                var formName = 'registration/education_details';
                hFormReference.getForm(formName).then(function (formObj) {
                    var scope = formObj.scope;
                    //load and show one work history one at a time.
                    var beforeLoadViewcallback = {};
                    beforeLoadViewcallback[formName] = function() {
                        var defer = $q.defer();

                        //loadAllWorkHistory and show one of them at a time
                        scope.nextEducation();

                        //load lookup degree
                        httpHelper.getList('degree_lookup', function(obj) {
                            defer.resolve();
                            return {degree: obj['degree'], id: obj.id };
                        }).then(function(r) {
                            defer.resolve();
                            scope.degrees = r;
                        }, function() {
                            defer.resolve();
                            scope.degrees = [];
                        });

//                        //load lookup degree
//                        httpHelper.getList('discipline_lookup').then(function(r) {
//                            scope.disciplines = r;
//                        }, function() {
//                            scope.disciplines = [];
//                        });


                        return defer.promise;
                    };
                    scope.beforeActiveViewCallback(beforeLoadViewcallback);

                    //re-structure the data for post request
                    var beforeSaveCallback = {};
                    beforeSaveCallback[formName] = function(formData, valid) {
                        if(!valid) return;

                        formData.education_id = scope.educationItem.education.UserEducation.id;
                        formData.institution_id = scope.educationItem.education.UserEducation.Institution.id;

                        if(formData.end_date=="") {
                            delete formData.end_date;
                        }

                        if (formData.still_in_school != undefined) {
                          if (formData.still_in_school == true) {
                            delete formData.end_date;
                          }
                          delete formData.still_in_school;
                        }

//                        if(formData.discipline_id) {
//                            formData.discipline_id = formData.discipline_id;
//                        }

                        if(formData.degree_id) {
                            formData.degree_id = formData.degree_id.id;
                        }

                        if(scope.educationItem.education.UserEducation.Institution.Location) {
                            //delete values if not the owner
                            try {
                                delete formData.google_location;
                            } catch(e) {}
                        }
                        return formData;
                    };
                    scope.addBeforeSaveCallback(beforeSaveCallback);

                });
            }
        };
    }])

    .directive('userMediaUpload', ['$q', 'asyncGlobalHandler', 'registrationApi', '$timeout', 'hUser', function($q, asyncGlobalHandler, registrationApi, $timeout, hUser) {
        return {
            link: function($scope, element, attr) {
                var photosUploadUrl = attr.ngUploadActionPhoto;
                if(photosUploadUrl.indexOf("http") == -1) {
                    photosUploadUrl =  publicConfiguration.APIServerBaseURL + photosUploadUrl;
                }

                var videosUploadUrl = attr.ngUploadActionVideo;
                if(videosUploadUrl.indexOf("http") == -1) {
                    videosUploadUrl =  publicConfiguration.APIServerBaseURL + videosUploadUrl;
                    videosUploadUrl = videosUploadUrl.replace('/v1/', '/v2/');
                }
                $scope.gallaryUploading = 0;
                $scope.gallaryUploadingTotal = 0;
                $scope.onVideoOrPhotoSelect = function ($files) {

                    if($files && $files.length == 0) {
                        return;
                    }

                    //add files to queue
                    var photos = [];
                    var videos = [];

                    for (var i = 0; i < $files.length; i++) {
                        if($files[i].type.indexOf("image")>= 0) {
                            $scope.gallaryUploadingTotal++;
                            photos.push($files[i]);
                        } else if ($files[i].type.indexOf("video")>= 0) {
                            $scope.gallaryUploadingTotal++;
                            videos.push($files[i]);
                        }
                    }

                    function doneUploading(data) {
                        $scope.gallaryUploading++;
                        if($scope.gallaryUploadingTotal === $scope.gallaryUploading) {
                            $scope.gallaryUploadingTotal = $scope.gallaryUploading = 0;
                        }
                    }

                    var p1 = $scope.directUpload(photos, photosUploadUrl, undefined, undefined, undefined, doneUploading);
                    var p2 = $scope.directUpload(videos, videosUploadUrl, undefined, undefined, undefined, doneUploading);

                    //asyncGlobalHandler.watchPromiseDict({photos:p1, videos:p2});

                    $q.all({photos:p1, videos:p2}).then(function(r) {
                        if(!angular.isArray($scope.user_gallery)) {
                            $scope.user_gallery = [];
                        }

                        for(var k in r.photos) {
                            $scope.user_gallery.push(
                                registrationApi.generateUserPhoto(r.photos[k].data.data,
                                    'gallery_images', hUser.data.user.id
                                )
                            );
                        }

                        for(var k in r.videos) {
                            $timeout(function() {
                                const videoData = r.videos[k].data.data;
                                const videoObj = {
                                    uuid: videoData.href ? videoData.href.split('/').slice(-2, -1)[0] : null,
                                    href: videoData.href,
                                    thumbnail_href: videoData.thumbnail_href,
                                    type: 'gallery_videos',
                                    absUrl: videoData.href
                                };
                                const galleryDetails = registrationApi.generateUserPhoto(
                                    videoObj.uuid,
                                    'gallery_videos'
                                )
                                videoObj.absUrl = galleryDetails.absUrl;
                                videoObj.path = galleryDetails.path;
                                $scope.user_gallery.push(videoObj);
                            }, 1500);
                        }
                    })
                };

            }
        }
    }])

    .filter('getUserMediaUrl', ['$state', 'hUser', function($state, hUser) {
        return function(uuid, slug) {
            if(!slug) {
                slug = hUser.data.user.slug;
            }

            var websiteUrl = $state.href('homepage', {}, {absolute: true});
            return websiteUrl + slug + "/media/" + uuid;
        };
    }])

    .directive('userMedia', ['hFormReference', '$q', 'httpHelper', 'registrationApi','googleMaps', 'asyncGlobalHandler', '$rootScope', 'hUser', function(hFormReference, $q, httpHelper, registrationApi, googleMaps, asyncGlobalHandler, $rootScope, hUser) {

        return {
            link: function($scope, element, attr) {

                var formName = 'registration/user_media';
                hFormReference.getForm(formName).then(function (formObj) {
                    var scope = formObj.scope;

                    //before loading view
                    var beforeLoadViewcallback = {};
                    beforeLoadViewcallback[formName] = function() {
                        var p = {};

                        p.gallery = registrationApi.user_gallery().then(function(data){
                            scope.user_gallery = data.gallery;
                            scope.video_domain = data.video_domain;
                        });

                        p.basic = registrationApi.getUserBasicPhotos().then(function(r) {
                            scope.userBasicPhotos = r;
                        });

                        scope.user = hUser.data.user;

                        return $q.all(p);
                    };
                    scope.beforeActiveViewCallback(beforeLoadViewcallback);

                    var beforeSavecallback = {};
                    beforeSavecallback[formName] = function() {
                        return false;
                    };
                    scope.addBeforeSaveCallback(beforeSavecallback);
                });



                $scope.descriptionChange = function(image) {
                    var p = registrationApi.updateUserMediaDetails(image);
                    asyncGlobalHandler.watchPromise(p);
                };

                $scope.removePhoto = function(image, index) {
                    var p = registrationApi.removeUserGallery(image.uuid);
                    asyncGlobalHandler.watchPromise(p);
                    $scope.user_gallery.splice(index,1);

                };


                $scope.showCroppingTool = function($files, url, type, imgId){

                    if($files.length){
                      $rootScope.$broadcast('showImageCroppingModalLoading');
                    }


                    var opt = {
                        file: $files? $files[0]: null,
                        imageMode: type == 'cover'? type: null,
                        croppingModalCallBack:function (coords, image) {

                            // Change Blob to look like a file
                            image.name = $files[0].name;
                            image.lastModifiedDate = $files[0].lastModifiedDate;

                            if (!imgId){
                                $scope.photoUpload([image], url, type, coords);
                            }
                        },
                        image_uuid: imgId,
                        updateCoordsOnClose: true
                    };

                    if( imgId ){
                        // Not used at current code
                        // opt['url'] = hMedia(null, {type:'user_photo', attr:'asItSs', size:'original', 'id':imgId }, true);
                    }

                    // send selected files && show modal
                    $rootScope.$broadcast('showImageCroppingModal', opt);
                };

                //upload photos only
                $scope.photoUpload = function ($files, url, type, coords) {

                    if ($files && $files.length == 0) {
                        return;
                    }

                    function uploadPhotoAction() {

                        //upload url
                        var photoUploadURL = url;

                        if (photoUploadURL.indexOf("http") == -1) {
                            photoUploadURL = publicConfiguration.APIServerBaseURL + photoUploadURL;
                        }

                        //add files to queue
                        var photos = [];

                        for (var i = 0; i < $files.length; i++) {
                            if ($files[i].type.indexOf("image") >= 0) {
                                photos.push($files[i]);
                            }
                        }

                        $scope[type + "loading"] = 0;
                        var p = $scope.directUpload(photos, photoUploadURL, undefined, ( coords ? coords : undefined ), function (file, percentage) {
                            if (percentage >= 95) percentage = 95;
                            $scope[type + "loading"] = percentage;
                        });


                        p.then(function (r) {
                            $scope[type + "loading"] = 100;
                            delete $scope[type + "loading"];

                            var data = {};
                            if (r[0] && r[0].data && r[0].data.data) {
                                data = r[0].data.data;
                            }
                            var image = registrationApi.generateUserPhoto(
                                data,
                                type
                            );

                            $scope.userBasicPhotos[type] = image;
                        })
                    }

                    if( url == 'background_photo' ){

                        Utils.validateMinSizeImageFromFile($files[0], {
                             'width': publicConfiguration.coverPhotoMinWidth,
                             'height': publicConfiguration.coverPhotoMinHeight
                         }, uploadPhotoAction);

                    }
                    else{
                         uploadPhotoAction();
                    }
                }
            }
        }

    }])

    .directive('brandMedia', ['hFormReference', '$stateParams', '$q', 'httpHelper', 'registrationApi','googleMaps', 'asyncGlobalHandler', '$timeout', '$rootScope', 'hUser', 'settingsFactory', 'brandServices',
        function (hFormReference, $stateParams, $q, httpHelper, registrationApi, googleMaps, asyncGlobalHandler, $timeout, $rootScope, hUser, settingsFactory, brandServices) {

        return {
            link: function($scope, element, attr) {

                var brand_id;
                var brand_slug;
                function updateBrandInformation() {
                    brand_id = $scope.media_brand_id || $stateParams.brand_id;
                    brand_slug = $scope.media_brand_slug;

                    if (brand_id) {
                        brandServices.check(brandServices.SERVICES.ON_BOARDING, brand_id)
                            .then((res) => {
                                $scope.onboardingEnabled = res;
                            })
                            .catch(console.error);
                    }
                }

                var formName = 'registration/brand_media';
                hFormReference.getForm(formName).then(function (formObj) {
                    var scope = formObj.scope;

                    //before loading view
                    var beforeLoadViewcallback = {};
                    beforeLoadViewcallback[formName] = function() {
                        updateBrandInformation();
                        if(brand_id) {
                            scope.brand_id = brand_id;
                        }
                    };
                    scope.beforeActiveViewCallback(beforeLoadViewcallback);

                    var beforeSavecallback = {};
                    beforeSavecallback[formName] = function() {
                        return false;
                    };
                    scope.addBeforeSaveCallback(beforeSavecallback);
                });
            }
        }

    }])

    .directive('hostedVideos', ['httpHelper','$stateParams', '$q', 'asyncGlobalHandler', 'registrationApi', 'hFormReference', function(httpHelper,$stateParams, $q, asyncGlobalHandler, registrationApi, hFormReference) {
        return {
            link: function($scope, element, attrs) {

                hFormReference.callbacks('registration/hosted_video', {
                    beforeActive: function() {
                        $("#join-modal .modal").animate({scrollTop:0});
                    }
                })


                if(!$scope.data) $scope.data = {};
                if(!$scope.data.hosted_video) $scope.data.hosted_video = {};
                $scope.data.hosted_video.videos = [];

                $scope.addVideo = function() {
                    $scope.data.hosted_video.videos.push({url:'', id: $scope.data.hosted_video.videos.length})
                };

                $scope.removeVideo = function(index) {
                  $scope.data.hosted_video.videos.splice(index, 1);
                }

                $scope.addVideo();

                var isSavingVideos = false;

                $scope.saveHostedVideos = function() {

                    if (isSavingVideos) {
                      return;
                    }

                    //validate
                    buttonElement = element.find('#save-videos')
                    buttonElement.button().button('loading');

                    var save = true;
                    var videos = [];

                    //validate
                    for(var k in $scope.data.hosted_video.videos) {
                        var video = $scope.data.hosted_video.videos[k];
                        var url = video.url;

                        var inputDivElement = element.find('#form_' + video.id);

                        var videoObj = MediaUtils.parseVideoURL(url);

                        if(!videoObj.type) {
                            inputDivElement.addClass('has-error');
                            save = false;
                        } else {
                            //correct url
                            videos.push(url);
                            inputDivElement.removeClass('has-error');
                        }
                    }

                    if(save && videos.length > 0) {
                        var promises = [];

                        _.each(videos, function(url) {
                            if($scope.isBrandMedia) {
                                promises.push(
                                    registrationApi.brandHostedVideoLink(url, $scope.media_brand_id || $stateParams.brand_id, $scope.media_brand_slug)
                                );
                            } else {
                                promises.push(
                                    registrationApi.userHostedVideoLink(url)
                                );
                            }
                        });

                        asyncGlobalHandler.watchPromiseDict(promises);

                        isSavingVideos = true;

                        $q.all(promises).then(function(r) {
                            // Reset hosted videos
                            $scope.data.hosted_video.videos = [];
                            $scope.addVideo();
                            isSavingVideos = false;

                            if(!angular.isArray($scope.user_gallery)) {
                                $scope.user_gallery = [];
                            }

                            for(var k in r) {
                                if($scope.isBrandMedia) {
                                    $scope.brand_gallery.push(

                                        registrationApi.generateBrandPhoto(
                                            r[k].data.data,
                                            'gallery_videos'
                                        )
                                    );
                                } else {

                                    $scope.user_gallery.push(
                                        registrationApi.generateUserPhoto(
                                            r[k].data.data,
                                            'gallery_videos'
                                        )
                                    );
                                }
                            }

                            buttonElement.button('reset');


                            if($scope.isBrandMedia) {
                                $scope.goto('registration/brand_media');
                            } else {
                                $scope.goto('registration/user_media');
                            }


                        }, function() {
                            isSavingVideos = false;
                            buttonElement.button('reset');
                        });
                    } else {
                        buttonElement.button('reset');
                    }
                }
            }
        }
    }])

    .directive('registrationSkills', ['registrationApi', '$timeout', 'hFormReference', '$parse', function(registrationApi, $timeout, hFormReference, $parse) {
        return {
            'link': function(scope) {

                var viewName = 'registration/skills';

                hFormReference.getForm(viewName).then(function() {

                    var beforeActiveCallbacks = {};
                    beforeActiveCallbacks[viewName] = function(r) {

                        registrationApi.getUserSkills().then(function(d) {
                            $parse('data.skills.skills').assign(scope, d);
                        });

                        registrationApi.getSkillLookup().then(function(skills) {
                            scope.skillsList = skills;
                        });

                    };

                    scope.beforeActiveViewCallback(beforeActiveCallbacks);


                    var beforeSaveCallbacks = {};
                    beforeSaveCallbacks[viewName] = function(formData) {
                        var data = {skills:[]};

                        _.each(formData.skills, function(skill) {
                            if(skill.skill_name) {
                                data.skills.push(skill);
                            } else {
                                data.skills.push(skill.id);
                            }
                        })

                        return data;
                    };

                    scope.addBeforeSaveCallback(beforeSaveCallbacks);


                });

                scope.skillsOptions = {
                    multiple: true
                };


            }
        }
    }])
